<div class="html-editor-wrapper">

  <ckeditor *ngIf="editMode" #editorRef [editor]="Editor" [(ngModel)]="value"
            (change)="contentChanged.emit(value)"
            (ready)="onReady($event)"></ckeditor>

  <div [hidden]="editMode" #content></div>

  <div class="buttons-container" *ngIf="showButtons">
    <button
      mat-raised-button
      *ngIf="editMode"
      class="mat-raised-button mat-primary"
      (click)="saveAboutPageContent()">
      {{'COMMON.SAVE' | translate}}
    </button>

    <button
      mat-raised-button
      *ngIf="!editMode"
      class="mat-raised-button"
      (click)="setEditMode()">
      {{'COMMON.EDIT' | translate}}
    </button>
  </div>


</div>
